import pluralizeLib from "pluralize";

// An acronym as the last word: two or more uppercase letters, digits allowed.
const ACRONYM = /^[A-Z][A-Z0-9]+$/;

/**
 * `pluralize(word, count, inclusive)` with acronyms pluralized by a lowercase
 * "s" ("2 SDEs", "3 PDFs"). The package restores the input's all-caps case on
 * its result, so it returns "SDES"; every other word is delegated unchanged.
 */
export default function pluralize(word, count, inclusive) {
	const lastWord = word.split(" ").pop();
	if (ACRONYM.test(lastWord) && count !== 1) {
		return `${inclusive ? `${count} ` : ""}${word}s`;
	}
	return pluralizeLib(word, count, inclusive);
}
